import { CartItem } from "../types/item";
import { useCartStore } from "../stores";
import useApp from "./app";

const useCartItem = () => {
  const removeFromStore = useCartStore((state) => state.remove);
  const { modal } = useApp();

  const remove = (item: CartItem, forever = false) => {
    const leavingTray = forever || item.quantity <= 1;
    if (!leavingTray) return removeFromStore(item, forever);
    modal.confirm({
      title: "Remove from cart?",
      description: `${item.name} will be removed from your cart.`,
      confirmText: "Remove",
      cancelText: "Keep",
      onConfirm: () => removeFromStore(item, forever),
    });
  };

  return { remove };
};

export default useCartItem;
